/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetAppShortlinkRequest} from '@cash-web/protos/squareup/cash/local/client/app/v1/cash_app_local_client_app_service.pb'
import {GetAppShortlinkResponse} from '@cash-web/protos/squareup/cash/local/client/app/v1/cash_app_local_client_app_service.pb'


export const getAppShortlink = (request:GetAppShortlinkRequest, options?: CashRequestOptions) => post<GetAppShortlinkRequest, GetAppShortlinkResponse>("/2.0/cash/get-app-shortlink", request, {...options, rejectOnError: true })